/** Clean up the former integration without loading the SDK or knowing its key. */
export const clearAnalyticsStorage = ({
	clearConsent = false,
}: {
	clearConsent?: boolean;
} = {}) => {
	if (typeof window === "undefined" || typeof document === "undefined") return;
	const tokens = new Set<string>();
	const rememberToken = (key: string) => {
		const match =
			/^ph_(.+)_(?:posthog|primary_window_exists|window_id)$/.exec(key) ??
			/^__ph_opt_in_out_(.+)$/.exec(key);
		if (match) tokens.add(match[1]);
	};
	try {
		for (const cookie of document.cookie.split(";")) {
			rememberToken(cookie.trim().split("=")[0]);
		}
	} catch {
		/* Continue with available browser storage. */
	}
	for (const storageName of ["localStorage", "sessionStorage"] as const) {
		try {
			const storage = window[storageName];
			for (const key of Object.keys(storage)) rememberToken(key);
			storage.removeItem("analytics-sdk-consent");
			if (clearConsent) {
				for (const key of [
					"analytics-consent",
					"analytics-consent-at",
					"analytics-consent-version",
				])
					storage.removeItem(key);
			}
		} catch {
			/* Storage may be unavailable in privacy-restricted browsers. */
		}
	}
	for (const token of tokens) {
		for (const storageName of ["localStorage", "sessionStorage"] as const) {
			try {
				const storage = window[storageName];
				for (const key of Object.keys(storage)) {
					if (
						key.startsWith(`ph_${token}_`) ||
						key === `__ph_opt_in_out_${token}`
					)
						storage.removeItem(key);
				}
			} catch {
				/* Keep removal best-effort when browser storage is blocked. */
			}
		}
		const expire = (name: string, domain = "") => {
			try {
				// biome-ignore lint/suspicious/noDocumentCookie: remove legacy analytics cookies.
				document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax${domain ? `; Domain=${domain}` : ""}`;
			} catch {
				// A blocked cookie store must not interrupt page rendering.
			}
		};
		for (const name of [`ph_${token}_posthog`, `__ph_opt_in_out_${token}`]) {
			expire(name);
			// The old SDK could set its cookie on the parent domain.
			const parts = window.location.hostname.split(".");
			while (parts.length >= 2) {
				expire(name, parts.join("."));
				parts.shift();
			}
		}
	}
};
